export const ui = {
  componentIds: {
    cmgAppContent: 'cmg-app-content',
  },
  breakpoints: {
    phoneXxsMax: 319,
    phoneXs: 320,
    phoneXsMax: 374,
    phoneSm: 375,
    phoneSmMax: 575,
    phoneLg: 576,
    phoneLgMax: 767,
    tablet: 768,
    tabletMax: 1023,
    desktop: 1024,
    desktopMax: 1199,
    desktopLg: 1200,
  },
  colors: {
    avocado: '#90a035',
    beige: '#f7f2ed',
    beigeTwo: '#f9f7f4',
    beigeLight: '#f8f2ec',
    beigeDark: '#eae1db',
    black: '#000000',
    blueLight: '#5d5e82',
    brown: '#451400',
    brownCocoa: '#54392d',
    brownDark: '#1b0800',
    brownSubtext: '#8c766d',
    brownLight: '#786259',
    dark: '#343a40',
    greyLight: '#f0f0f0',
    greyMedium: '#f2f2f2',
    greyPinkish: '#d4cbc7',
    greyishBrown: '#756456',
    greenMedium: '#68831c',
    greenDark: '#417505',
    greenXdark: '#5f6b19',
    goldNew: '#a76721',
    gold: '#b68207',
    goldLight: '#debf79',
    goldDark: '#976500',
    goldMedium: '#c97900',
    linen: '#dfd9d3',
    pink: '#96436a',
    red: '#ad2118',
    redBurnt: '#9c1f16',
    redLight: '#d0021b',
    redDark: '#88120a',
    rustyRed: '#ac2318',
    yellowCarbs: '#d49b1c',
    white: '#ffffff',
    scarlet: '#d0021b',
  },
};

export const external = {
  stateCodes: [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
    'DC',
  ],
  states: [
    { formatted: 'Alabama', value: 'AL' },
    { formatted: 'Alaska', value: 'AK' },
    { formatted: 'Arizona', value: 'AZ' },
    { formatted: 'Arkansas', value: 'AR' },
    { formatted: 'California', value: 'CA' },
    { formatted: 'Colorado', value: 'CO' },
    { formatted: 'Connecticut', value: 'CT' },
    { formatted: 'Delaware', value: 'DE' },
    { formatted: 'Florida', value: 'FL' },
    { formatted: 'Georgia', value: 'GA' },
    { formatted: 'Hawaii', value: 'HI' },
    { formatted: 'Idaho', value: 'ID' },
    { formatted: 'Illinois', value: 'IL' },
    { formatted: 'Indiana', value: 'IN' },
    { formatted: 'Iowa', value: 'IA' },
    { formatted: 'Kansas', value: 'KS' },
    { formatted: 'Kentucky', value: 'KY' },
    { formatted: 'Louisiana', value: 'LA' },
    { formatted: 'Maine', value: 'ME' },
    { formatted: 'Maryland', value: 'MD' },
    { formatted: 'Massachusetts', value: 'MA' },
    { formatted: 'Michigan', value: 'MI' },
    { formatted: 'Minnesota', value: 'MN' },
    { formatted: 'Mississippi', value: 'MS' },
    { formatted: 'Missouri', value: 'MO' },
    { formatted: 'Montana', value: 'MT' },
    { formatted: 'Nebraska', value: 'NE' },
    { formatted: 'Nevada', value: 'NV' },
    { formatted: 'New Hampshire', value: 'NH' },
    { formatted: 'New Jersey', value: 'NJ' },
    { formatted: 'New Mexico', value: 'NM' },
    { formatted: 'New York', value: 'NY' },
    { formatted: 'North Carolina', value: 'NC' },
    { formatted: 'North Dakota', value: 'ND' },
    { formatted: 'Ohio', value: 'OH' },
    { formatted: 'Oklahoma', value: 'OK' },
    { formatted: 'Oregon', value: 'OR' },
    { formatted: 'Pennsylvania', value: 'PA' },
    { formatted: 'Rhode Island', value: 'RI' },
    { formatted: 'South Carolina', value: 'SC' },
    { formatted: 'South Dakota', value: 'SD' },
    { formatted: 'Tennessee', value: 'TN' },
    { formatted: 'Texas', value: 'TX' },
    { formatted: 'Utah', value: 'UT' },
    { formatted: 'Vermont', value: 'VT' },
    { formatted: 'Virginia', value: 'VA' },
    { formatted: 'Washington', value: 'WA' },
    { formatted: 'West Virginia', value: 'WV' },
    { formatted: 'Wisconsin', value: 'WI' },
    { formatted: 'Wyoming', value: 'WY' },
    { formatted: 'District of Columbia', value: 'DC' },
  ],
  canadianProvinces: [
    { formatted: 'Alberta', value: 'AB' },
    { formatted: 'British Columbia', value: 'BC' },
    { formatted: 'Manitoba', value: 'MB' },
    { formatted: 'New Brunswick', value: 'NB' },
    { formatted: 'Newfoundland and Labrador', value: 'NL' },
    { formatted: 'Nova Scotia', value: 'NS' },
    { formatted: 'Ontario', value: 'ON' },
    { formatted: 'Prince Edward Island', value: 'PE' },
    { formatted: 'Quebec', value: 'QC' },
    { formatted: 'Saskatchewan', value: 'SK' },
    { formatted: 'Northwest Territories', value: 'NT' },
    { formatted: 'Nunavut', value: 'NU' },
    { formatted: 'Yukon', value: 'YT' },
  ],
  ukCounties: [
    { formatted: 'Bedfordshire', value: 'Bedfordshire' },
    { formatted: 'Berkshire', value: 'Berkshire' },
    { formatted: 'Bristol', value: 'Bristol' },
    { formatted: 'Buckinghamshire', value: 'Buckinghamshire' },
    { formatted: 'Cambridgeshire', value: 'Cambridgeshire' },
    { formatted: 'Cheshire', value: 'Cheshire' },
    { formatted: 'London', value: 'London' },
    { formatted: 'Cornwall', value: 'Cornwall' },
    { formatted: 'County Durham', value: 'County Durham' },
    { formatted: 'Cumbria', value: 'Cumbria' },
    { formatted: 'Derbyshire', value: 'Derbyshire' },
    { formatted: 'Devon', value: 'Devon' },
    { formatted: 'Dorset', value: 'Dorset' },
    { formatted: 'East Riding of Yorkshire', value: 'East Riding of Yorkshire' },
    { formatted: 'East Sussex', value: 'East Sussex' },
    { formatted: 'Essex', value: 'Essex' },
    { formatted: 'Gloucestershire', value: 'Gloucestershire' },
    { formatted: 'Greater London', value: 'Greater London' },
    { formatted: 'Greater Manchester', value: 'Greater Manchester' },
    { formatted: 'Hampshire', value: 'Hampshire' },
    { formatted: 'Herefordshire', value: 'Herefordshire' },
    { formatted: 'Hertfordshire', value: 'Hertfordshire' },
    { formatted: 'Isle of Wight', value: 'Isle of Wight' },
    { formatted: 'Kent', value: 'Kent' },
    { formatted: 'Lancashire', value: 'Lancashire' },
    { formatted: 'Leicestershire', value: 'Leicestershire' },
    { formatted: 'Lincolnshire', value: 'Lincolnshire' },
    { formatted: 'Merseyside', value: 'Merseyside' },
    { formatted: 'Norfolk', value: 'Norfolk' },
    { formatted: 'North Yorkshire', value: 'North Yorkshire' },
    { formatted: 'Northamptonshire', value: 'Northamptonshire' },
    { formatted: 'Northumberland', value: 'Northumberland' },
    { formatted: 'Nottinghamshire', value: 'Nottinghamshire' },
    { formatted: 'Oxfordshire', value: 'Oxfordshire' },
    { formatted: 'Rutland', value: 'Rutland' },
    { formatted: 'Shropshire', value: 'Shropshire' },
    { formatted: 'Somerset', value: 'Somerset' },
    { formatted: 'South Yorkshire', value: 'South Yorkshire' },
    { formatted: 'Staffordshire', value: 'Staffordshire' },
    { formatted: 'Suffolk', value: 'Suffolk' },
    { formatted: 'Surrey', value: 'Surrey' },
    { formatted: 'Tyne and Wear', value: 'Tyne and Wear' },
    { formatted: 'Warwickshire', value: 'Warwickshire' },
    { formatted: 'West Midlands', value: 'West Midlands' },
    { formatted: 'West Sussex', value: 'West Sussex' },
    { formatted: 'West Yorkshire', value: 'West Yorkshire' },
    { formatted: 'Wiltshire', value: 'Wiltshire' },
    { formatted: 'Worcestershire', value: 'Worcestershire' },
  ]
};

export interface Country {
  countryCode: string;
  name: string;
  shortName: string;
  namePrefix: string;
  lat: number;
  lng: number;
  currencySymbol: string;
  currencySymbolShort: string;
  currencyName: string;
  distanceUnit: string;
  isActive: boolean;
  isLoyaltyEnabled: boolean;
  isSustainablityEnabled: boolean;
  isAutoSubscribesToLoyaltyEmail: boolean;
  isAutoSubscribesToMarketingEmail: boolean;
  topLevelDomain: string;
  createAccountOptions: CreateAccountOptions;
  strings: CountryStrings;
  locale: string;
  validations: Validations;
  isPepperEnabled: boolean;
  isCateringEnabled: boolean;
  isDonationsEnabled: boolean;
  isGiftCardsEnabled: boolean;
  isFoodprintEnabled: boolean;
  isFeedbackSurveyEnabled: boolean;
  isRewardsOnline: boolean;
  facOptions: FACOptions;
  bagOptions: BagOptions;
  paymentOptions: PaymentOptions;
  minimumAgeOfEligibility: number;
  isAdobeAnalyticsEnabled: boolean;
  isExtrasOptinEnabled: boolean;
  isAlternatePickupEnabled: boolean;
}

export interface Validations {
  zipCode: {
    maxLength: number,
    formatRegex: RegExp
  }
}

export interface Countries {
  [key: string]: Country;
}

export interface CountryStrings {
  [key: string]: string;
}

export interface CreateAccountOptions {
  showBirthdayField: boolean;
  showEmailPromotionsRadioButton: boolean;
  showCountryRadioButton: boolean;
}

export interface FACOptions {
  isDeliveryEnabled: boolean;
  showCateringOptionDefault: boolean;
  googleMapsZoomLevel: number;
}

export interface BagOptions {
  isRewardsOnline: boolean;
  useRewardsMedallionStyling: boolean;
}

export interface PaymentOptions {
  aboveStorePaymentOnline: boolean;
  isChasePaymentOnline: boolean;
  isChaseUKPaymentOnline: boolean;
  isUComPaymentOnline: boolean;
}

export const countries: Countries = {
  us: {
    countryCode: 'US',
    name: 'United States',
    shortName: 'U.S.',
    namePrefix: 'the',
    lat: 37.09024,
    lng: -95.712891,
    currencySymbol: '$',
    currencySymbolShort: '$',
    currencyName: 'US Dollars',
    distanceUnit: 'mi',
    isActive: true,
    isLoyaltyEnabled: true,
    isSustainablityEnabled: true,
    isAutoSubscribesToLoyaltyEmail: false,
    isAutoSubscribesToMarketingEmail: true,
    topLevelDomain: '.com',
    createAccountOptions: {
      showBirthdayField: true,
      showCountryRadioButton: true,
      showEmailPromotionsRadioButton: false,
    },
    facOptions: {
      isDeliveryEnabled: true,
      showCateringOptionDefault: true,
      googleMapsZoomLevel: 4
    },
    bagOptions: {
      isRewardsOnline: true,
      useRewardsMedallionStyling: true
    },
    paymentOptions: {
      aboveStorePaymentOnline: true,
      isChasePaymentOnline: false,
      isChaseUKPaymentOnline: false,
      isUComPaymentOnline: true
    },
    strings: {
      signInContainerTitle: 'Already have an account?',
    },
    locale: 'en-US',
    validations: {
      zipCode: {
        maxLength: 5,
        formatRegex:/^\d{5}$/
      }
    },
    isPepperEnabled: true,
    isCateringEnabled: true,
    isDonationsEnabled: true,
    isGiftCardsEnabled: true,
    isFeedbackSurveyEnabled: true,
    isFoodprintEnabled: true,
    isRewardsOnline: true,
    minimumAgeOfEligibility: 13,
    isAdobeAnalyticsEnabled: true,
    isExtrasOptinEnabled: true,
    isAlternatePickupEnabled: true
  },
  ca: {
    countryCode: 'CA',
    name: 'Canada',
    shortName: 'CA',
    namePrefix: '',
    lat: 56.1304,
    lng: -106.3468,
    currencySymbol: 'CA $',
    currencySymbolShort: '$',
    currencyName: 'CA Dollars',
    distanceUnit: 'km',
    isActive: true,
    isLoyaltyEnabled: true,
    isSustainablityEnabled: false,
    isAutoSubscribesToLoyaltyEmail: false,
    isAutoSubscribesToMarketingEmail: false,
    topLevelDomain: '.ca',
    createAccountOptions: {
      showBirthdayField: true,
      showCountryRadioButton: true,
      showEmailPromotionsRadioButton: true,
    },
    facOptions: {
      isDeliveryEnabled: true,
      showCateringOptionDefault: true,
      googleMapsZoomLevel: 4
    },
    bagOptions: {
      isRewardsOnline: true,
      useRewardsMedallionStyling: true
    },
    paymentOptions: {
      aboveStorePaymentOnline: true,
      isChasePaymentOnline: true,
      isChaseUKPaymentOnline: false,
      isUComPaymentOnline: false
    },
    strings: {
      signInContainerTitle: 'Have an account?',
    },
    locale: 'en-CA',
    validations: {
      zipCode: {
        maxLength: 7,
        formatRegex:/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] ?\d[ABCEGHJ-NPRSTV-Z]\d$/i
      }
    },
    isPepperEnabled: true,
    isCateringEnabled: true,
    isDonationsEnabled: true,
    isGiftCardsEnabled: true,
    isFeedbackSurveyEnabled: true,
    isFoodprintEnabled: true,
    isRewardsOnline: true,
    minimumAgeOfEligibility: 16,
    isAdobeAnalyticsEnabled: true,
    isExtrasOptinEnabled: true,
    isAlternatePickupEnabled: true
  },
};

export const enum PaymentProviders {
  Payeezy = 'PYEZ',
  Chase = 'CHAS',
  ChaseUK = 'CHASUK',
  UCom = 'UCOM',
}

export const USPaymentProviders: string[] =  [
  PaymentProviders.Payeezy,
  PaymentProviders.UCom
]

export const CAPaymentProviders: string[] = [
  PaymentProviders.Chase
]

export const UKPaymentProviders: string[] = [
  PaymentProviders.ChaseUK
]

export const RESIZE_LISTENER_POLL_RATE_MS = 50;

export const NAPKINS_AND_UTENSILS_MENU_ID = 'CMG-6110';

export const BYOFM_BOWLS_MENU_ID = 'CMG-6111';

export const BYOFM_SERVING_UTENSILS_MENU_ID = 'CMG-6112';

export const AUTOMATIC_PERSONALIZATION_AGE = 18;

export const AUTOMATIC_EMAIL_MARKETING_AGE = 18;
